// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kop{background-color:#fff;border:1px solid #ddd;border-radius:.5rem;margin:1rem 0;position:relative;width:95%;max-width:1200px}.label{margin-left:1rem;background-color:#0d0d0d;font-size:.6rem;letter-spacing:1px;font-weight:700;text-transform:uppercase;color:#fff;position:absolute;top:0;padding:.25rem .75rem;border-radius:0 0 .5rem .5rem}.kop-content{margin:2.5rem 1rem 1rem;padding:.5rem;border:2px dashed rgba(13,13,13,.12549019607843137);border-radius:.5rem}", ""]);
// Exports
module.exports = exports;
